export default "<router-outlet></router-outlet>\r\n\r\n<lib-alert-popup></lib-alert-popup>"